import { createAsyncThunk } from "@reduxjs/toolkit";
import { axios_api, server_base_endpoints } from "../../api";
import { ISelectOption } from "../../constants/types";
import { formatText } from "../../helpers";



export const fetchTableOrColumnNamesAsync = createAsyncThunk<ISelectOption[], { onCallback: (modules: ISelectOption[]) => void, tableName?: string,  }>(
    'general/fetchTableOrColumnNamesAsync', async ({ tableName, onCallback }, thunkAPI) => {
        try {
            let base_url = `${server_base_endpoints.general.get_table_or_column_name}?table_type=VIEW`
            if (tableName) {
                base_url += "&table_name=" + tableName;
            }
            const response = await axios_api.get(base_url)

            const data: string[] = response.data.data;
            const finalData: ISelectOption[] = data.map((item) => ({ label: formatText(item), value: item }))
            onCallback(finalData);
            return finalData; // ✅ Ensure the function returns the expected value
        } catch (err: any) {
            onCallback([]);
            return thunkAPI.rejectWithValue(err.message || "Failed to fetch data");
        }
    },
)